export var ZeroEtlTableFormat;
(function (ZeroEtlTableFormat) {
    ZeroEtlTableFormat["ZERO_ETL_TABLE_FORMAT_ICEBERG"] = "ICEBERG";
    ZeroEtlTableFormat["ZERO_ETL_TABLE_FORMAT_DELTA"] = "DELTA";
})(ZeroEtlTableFormat || (ZeroEtlTableFormat = {}));
